import { useState } from "react";
import CreateSharingInvitationModal from "../../../../../../components/CreateSharingInvitationModal";
import Schedule from "../Schedule";
import { EventFragment } from "../../../../../../__generated__/graphql";
import { useUser } from "../../../../../../contexts/UserContext/hooks/useUser";
import { FaCalendar } from "react-icons/fa";
import { FaFilePdf } from "react-icons/fa6";
import CreateActivityButton from "./components/CreateActivityButton";
import Button from "../../../../../../components/Button";
import ExportScheduleModal from "../../../../../../components/ExportScheduleModal";

export default function EventPlanning({ event }: { event: EventFragment }) {
  const { currentOrganization } = useUser();

  const [isInviteCollaboratorModalOpen, setIsInviteCollaboratorModalOpen] =
    useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);

  const isOwner = currentOrganization?.id === event.ownerOrganizationId;
  const hasActivities = event.activities && event.activities.length > 0;

  return (
    <>
      <CreateSharingInvitationModal
        title="Inviter des participants"
        description="Pour assigner des artistes à un évènement, vous devez d'abord les inviter à rejoindre Kontrol."
        isModalOpen={isInviteCollaboratorModalOpen}
        onClose={() => setIsInviteCollaboratorModalOpen(false)}
      />

      <ExportScheduleModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        event={event}
      />

      <div className="w-full flex flex-col gap-4 border border-input rounded-md p-4">
        <div className="flex justify-between items-center">
          <div className="text-lg font-bold flex items-center gap-2">
            <FaCalendar />
            Planning
          </div>

          <div className="flex items-center gap-2">
            {hasActivities && (
              <Button
                variant="secondary"
                onClick={() => setIsExportModalOpen(true)}
                className="flex items-center gap-2"
              >
                <FaFilePdf className="w-4 h-4" />
                Exporter
              </Button>
            )}
            {isOwner ? <CreateActivityButton eventId={event.id} /> : null}
          </div>
        </div>

        <Schedule event={event} />
      </div>
    </>
  );
}
